<template>
  <section class="wrap_pop">
    <div class="popbox_wrap">
      <div class="popbox_cont">
        <div class="popbox_cont_head">
          <strong class="pop_tit">출력물 확인</strong>
        </div>
        <!-- 출력물 영역 -->
        <div class="popbox_container">
          <VueperSlides
            class="no-shadow"
            slide-image-inside
            fixed-height="100%"
            ref="slide"
            :arrows="false"
            :bullets="false"
            :infinite="false"
            @ready="onReady"
            @slide="onSlide"
          >
            <VueperSlide
              v-for="(vo, i) in data"
              :key="i"
              :image="
                vo.isSigned
                  ? vo.signImageData
                  : vo.isAgr
                  ? vo.agrImageData
                  : vo.imageData
              "
            />
          </VueperSlides>
        </div>
        <!-- <template #arrow-left> -->
        <button
          type="button"
          class="pop_arrow btn_prev"
          :class="currentSlideIdx == 0 ? 'hide' : ''"
          @click="goPrev()"
        >
          <span>이전</span>
        </button>
        <!-- </template> -->

        <!-- <template #arrow-right> -->
        <button type="button" class="pop_arrow btn_next" @click="goNext()">
          <span>다음</span>
        </button>
        <!-- </template> -->
        <!-- // 출력물 영역 -->
        <button class="pop_full_close" @click="close()">
          <span>닫기</span>
        </button>
        <div class="popbox_btn">
          <div>
            <button type="button" class="btn color1" @click="confirm">
              {{ buttonLabel }}
            </button>
          </div>
        </div>

        <div
          class="swipe_area"
          v-if="data.length > 1"
          :class="data.length >= 10 ? 'step-over10' : ''"
        >
          <VueSlider
            :marks="true"
            :tooltip="'always'"
            :dotSize="0"
            :max="data.length - 1"
            :height="5"
            :class="isLastSlide ? 'process-100per' : ''"
            v-model="currentSlideIdx"
            @change="(idx) => slide.goToSlide(idx)"
          >
            <template v-slot:mark="{ value, pos }">
              <div
                class="custom-sign-step"
                :class="data[value].isSigned ? 'sign-ok' : ''"
                :style="{ left: `${pos}%` }"
                v-if="data[value].isSignRequired"
              ></div>
              <div
                class="custom-sign-step-label"
                :class="data[value].isSigned ? 'sign-ok' : ''"
                :style="{ left: `${pos}%` }"
                v-if="data[value].isSignRequired"
              >
                {{ getSliderLabel(value) }}
              </div>
            </template>
          </VueSlider>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { ref } from 'vue'
import useDialog from '@/common/dialog'
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
export default {
  components: {
    VueperSlides,
    VueperSlide,
    VueSlider,
  },
  props: {
    data: Array,
  },

  setup(props, context) {
    const dialog = useDialog()
    const slide = ref(null)
    const currentSlideIdx = ref(0)
    const isSignPage = ref(false)
    const isLastSlide = ref(false)
    const buttonLabel = ref('다음 페이지')
    let isViewedLastSlide = false

    const confirm = () => {
      if (isSignPage.value && !props.data[currentSlideIdx.value].isSigned) {
        props.data[currentSlideIdx.value].isSigned = true
        isSignPage.value = false
        if (isLastSlide.value) {
          buttonLabel.value = '문서목록으로 이동'
        } else {
          buttonLabel.value = '다음 페이지'
        }
      } else if (slide.value.slidesCount - 1 == currentSlideIdx.value) {
        // 마지막 슬라이드 일 경우
        // 서명이 필요한 화면에서 서명입력을 하지 않았을 경우
        chkSgnNcssIdx()
      } else {
        slide.value.next()
      }
    }

    const onReady = () => {
      if (currentSlideIdx.value == props.data.length - 1) {
        isLastSlide.value = true
        isViewedLastSlide = true
        buttonLabel.value = '문서목록으로 이동'
      } else {
        isLastSlide.value = false
      }

      if (
        props.data[currentSlideIdx.value].isSignRequired &&
        !props.data[currentSlideIdx.value].isSigned
      ) {
        isSignPage.value = true
        buttonLabel.value = '서명입력'
      }
    }

    const onSlide = (slide) => {
      currentSlideIdx.value = slide.currentSlide.index

      if (currentSlideIdx.value == props.data.length - 1) {
        isLastSlide.value = true
        isViewedLastSlide = true
      } else {
        isLastSlide.value = false
      }

      if (
        props.data[currentSlideIdx.value].isSignRequired &&
        !props.data[currentSlideIdx.value].isSigned
      ) {
        isSignPage.value = true
        buttonLabel.value = '서명입력'
      } else {
        isSignPage.value = false
        if (isLastSlide.value) {
          buttonLabel.value = '문서목록으로 이동'
        } else {
          buttonLabel.value = '다음 페이지'
        }
      }
    }

    const goNext = () => {
      if (currentSlideIdx.value == props.data.length - 1) {
        confirm()
      } else {
        slide.value.next()
      }
    }

    const goPrev = () => {
      slide.value.previous()
    }

    const getSliderLabel = (idx) => {
      if (props.data[idx].isSignRequired && props.data[idx].isSigned) {
        return '완료'
      } else if (props.data[idx].isSignRequired && !props.data[idx].isSigned) {
        return '서명'
      } else {
        return ''
      }
    }

    const close = () => {
      if (isViewedLastSlide || props.data.length == 1) {
        chkSgnNcssIdx()
      } else {
        context.emit('close')
      }
    }

    function chkSgnNcssIdx() {
      let sgnNcssIdx = _.findIndex(
        props.data,
        (res) => res.isSignRequired && !res.isSigned
      )
      if (sgnNcssIdx != -1) {
        dialog
          .alert(
            '서명이 전부 완료되지 않았습니다. 출력물을 확인하여 서명입력 후 진행하여 주세요.'
          )
          .then(() => {
            slide.value.goToSlide(sgnNcssIdx)
          })
      } else {
        context.emit('close', 'success')
      }
    }

    return {
      slide,
      currentSlideIdx,
      confirm,
      onReady,
      onSlide,
      isSignPage,
      goNext,
      goPrev,
      getSliderLabel,
      isLastSlide,
      close,
      buttonLabel,
    }
  },
}
</script>

<style>
.vueperslide__image {
  background-size: contain;
  background-repeat: no-repeat;
}
.slider-blue {
  --slider-connect-bg: #7e67df;
  --slider-tooltip-bg: #7e67df;
  --slider-bg: #f0f0f0;
}
.pop_arrow.hide {
  display: none !important;
}
.pop_arrow {
  z-index: 5;
}

/* 출력물확인 slider 2021-12-08 */
.swipe_area {
  position: fixed;
  left: 50%;
  top: 65px;
  width: 155px;
  height: 10px;
  margin: 0;
  background: #fff;
  z-index: 10;
  transform: translateX(-50%);
}
.swipe_area.step-over10 {
  width: 300px;
}
.swipe_area .vue-slider.process-100per .vue-slider-rail::after {
  background: #7e67df;
} /* process bar 100% 경우 */
/*.swipe_area .vue-slider {height:5px !important;}*/
.vue-slider-dot-tooltip-top {
  top: 2px;
}
.vue-slider-rail {
  position: relative;
  background-color: #ebebeb;
  border-radius: 15px;
}
.vue-slider-rail::before,
.vue-slider-rail::after {
  content: '';
  display: block;
  position: absolute;
  top: 50%;
  width: 3px;
  height: 13px;
  border-radius: 2px;
  background: #ebebeb;
  transform: translateY(-50%);
}
.vue-slider-rail::before {
  left: -1.5px;
  background: #7e67df;
}
.vue-slider-rail::after {
  right: -1.5px;
}

.vue-slider-process {
  background-color: #7e67df;
}
.vue-slider-dot-handle {
  box-shadow: none;
}
.vue-slider-dot-tooltip-inner {
  min-width: 20px;
  width: 32px;
  height: 38px;
  padding: 0;
  box-sizing: border-box;
  border-radius: 0;
  border: none;
  background: none;
  color: #fff;
  text-align: center;
  box-shadow: none;
  background: url(~@/assets/images/contents/slider_tooltip_bg.png) no-repeat top
    center;
  background-size: 100%;
}
.vue-slider-dot-tooltip-inner .vue-slider-dot-tooltip-text {
  display: block;
  padding-top: 3px;
  color: #fff;
  line-height: 24px;
  text-align: center;
}
.vue-slider-dot-tooltip-inner-top::after {
  display: none;
}

.vue-slider-mark {
  display: none;
}

/* sign style */
.custom-sign-step {
  position: absolute;
  top: 50%;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: #d01111;
  transform: translate(-50%, -50%);
  z-index: 3;
}
.custom-sign-step-label {
  position: absolute;
  top: 14px;
  font-size: 0.6875rem;
  transform: translateX(-50%);
  white-space: nowrap;
}
.custom-sign-step.sign-ok {
  background: #7e67df url(~@/assets/images/contents/slider_sign_check.png)
    no-repeat center;
  background-size: 100%;
} /* 완료 */
.custom-sign-step-label.sign-ok {
  color: #999;
}
</style>
